/**
 * JV. Calculadora de Gravidez
 * Script principal com lógica de cálculo e captura de leads
 * Versão simplificada - Salva como newsletter com tags
 */

class CalculadoraGravidez {
  constructor() {
    this.form = document.getElementById('jvCalcForm');
    this.resultDiv = document.getElementById('jvCalcResult');
    this.popupOverlay = document.getElementById('jvCalcPopup');
    this.popupForm = document.getElementById('jvPopupForm');
    this.criterioSelect = document.getElementById('criterio-calculo');
    this.dataInput = document.getElementById('data-input');
    this.dataLabel = document.getElementById('data-label');
    this.campoCiclo = document.getElementById('campo-ciclo-wrapper');
    this.campoFIV = document.getElementById('campo-fiv-wrapper');
    this.campoUltrassom = document.getElementById('campo-ultrassom-wrapper');
    this.resultadoDPP = null;
    this.tagDPP = null;
    
    // Obter cores da seção
    this.sectionElement = document.querySelector('.jv-calc-gravidez');
    this.sectionId = this.sectionElement?.dataset.sectionId;
    
    this.init();
    this.injetarCoresPopup();
  }

  init() {
    // Event listeners
    this.form?.addEventListener('submit', (e) => this.calcular(e));
    this.criterioSelect?.addEventListener('change', () => this.mudarCriterio());
    document.getElementById('btnRecalcular')?.addEventListener('click', () => this.recalcular());
    document.getElementById('btnClosePopup')?.addEventListener('click', () => this.fecharPopup());
    document.getElementById('linkConcepcao')?.addEventListener('click', (e) => this.mostrarConcepcao(e));
    document.getElementById('togglePassword')?.addEventListener('click', () => this.togglePassword());
    document.getElementById('calcularDPPLink')?.addEventListener('click', (e) => this.voltarParaCalculo(e));
    // Removi o listener de submit do popupForm - agora é gerenciado pelo script inline
    
    // Fechar popup ao clicar fora
    this.popupOverlay?.addEventListener('click', (e) => {
      if (e.target === this.popupOverlay) {
        this.fecharPopup();
      }
    });
    
    // Fechar popup com ESC
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.popupOverlay.style.display === 'flex') {
        this.fecharPopup();
      }
    });
    
    // Chamar mudarCriterio() no carregamento para exibir campos corretos
    this.mudarCriterio();
  }

  injetarCoresPopup() {
    // Obter cores das variáveis CSS da seção
    if (!this.sectionElement) return;
    
    const styles = getComputedStyle(document.documentElement);
    const sectionId = this.sectionId;
    
    // Criar variáveis CSS globais para o popup
    const popupBgColor = styles.getPropertyValue(`--jv-calc-${sectionId}-popup-bg-color`).trim();
    const popupTextColor = styles.getPropertyValue(`--jv-calc-${sectionId}-popup-text-color`).trim();
    const popupInputBg = styles.getPropertyValue(`--jv-calc-${sectionId}-popup-input-bg`).trim();
    const popupButtonBg = styles.getPropertyValue(`--jv-calc-${sectionId}-popup-button-bg`).trim();
    const popupButtonTextColor = styles.getPropertyValue(`--jv-calc-${sectionId}-popup-button-text-color`).trim();
    const borderRadius = styles.getPropertyValue(`--jv-calc-${sectionId}-border-radius`).trim();
    
    // Aplicar estilos inline no popup
    if (this.popupOverlay) {
      const popup = this.popupOverlay.querySelector('.jv-calc-popup');
      if (popup && popupBgColor) {
        popup.style.setProperty('background', popupBgColor, 'important');
        popup.style.setProperty('color', popupTextColor, 'important');
        popup.style.setProperty('border-radius', `calc(${borderRadius} * 2)`, 'important');
      }
      
      // Aplicar nos inputs
      const inputs = this.popupOverlay.querySelectorAll('.jv-calc-popup-field input');
      inputs.forEach(input => {
        if (popupInputBg) {
          input.style.setProperty('background', popupInputBg, 'important');
          input.style.setProperty('color', popupTextColor, 'important');
        }
      });
      
      // Aplicar no botão
      const button = this.popupOverlay.querySelector('.jv-calc-popup-submit');
      if (button && popupButtonBg) {
        button.style.setProperty('background', popupButtonBg, 'important');
        button.style.setProperty('color', popupButtonTextColor, 'important');
      }
    }
  }

  mudarCriterio() {
    const criterio = this.criterioSelect.value;
    
    // Resetar todos os campos específicos
    this.campoCiclo.style.display = 'none';
    this.campoFIV.style.display = 'none';
    this.campoUltrassom.style.display = 'none';
    
    // Configurar label e campos baseado no critério
    switch(criterio) {
      case 'ciclo-anterior':
        this.dataLabel.textContent = 'Qual foi o primeiro dia da sua última menstruação?';
        this.campoCiclo.style.display = 'block';
        this.dataInput.type = 'date';
        break;
      case 'data-concepcao':
        this.dataLabel.textContent = 'Qual foi a data da concepção?';
        this.dataInput.type = 'date';
        break;
      case 'fiv':
        this.dataLabel.textContent = 'Qual foi a data da transferência do embrião?';
        this.campoFIV.style.display = 'block';
        this.dataInput.type = 'date';
        break;
      case 'ultrassom':
        this.dataLabel.textContent = 'Qual foi a data do ultrassom?';
        this.campoUltrassom.style.display = 'block';
        this.dataInput.type = 'date';
        break;
      case 'dpp':
        this.dataLabel.textContent = 'Qual é a data provável do parto?';
        this.dataInput.type = 'date';
        break;
    }
  }

  calcular(e) {
    e.preventDefault();
    
    const criterio = this.criterioSelect.value;
    const data = new Date(this.dataInput.value + 'T12:00:00');
    
    if (isNaN(data.getTime())) {
      alert('Por favor, insira uma data válida.');
      return;
    }
    
    let dpp;
    
    switch(criterio) {
      case 'ciclo-anterior':
        dpp = this.calcularPorCiclo(data);
        break;
      case 'data-concepcao':
        dpp = this.calcularPorConcepcao(data);
        break;
      case 'fiv':
        dpp = this.calcularPorFIV(data);
        break;
      case 'ultrassom':
        dpp = this.calcularPorUltrassom(data);
        break;
      case 'dpp':
        dpp = data;
        break;
    }
    
    this.resultadoDPP = dpp;
    this.tagDPP = this.gerarTag(dpp);
    this.mostrarResultado(dpp);
    
    // Agendar popup
    const popupDelay = parseInt(this.sectionElement?.dataset.popupDelay || 5);
    
    setTimeout(() => {
      this.mostrarPopup(dpp);
    }, popupDelay * 1000);
  }

  calcularPorCiclo(dum) {
    // Regra de Naegele: DUM - 3 meses + 7 dias + ajuste do ciclo
    const duracaoCiclo = parseInt(document.getElementById('duracao-ciclo')?.value || 28);
    const dpp = new Date(dum);
    
    // Ajuste baseado na duração do ciclo
    const diferencaCiclo = duracaoCiclo - 28;
    
    dpp.setMonth(dpp.getMonth() + 9);
    dpp.setDate(dpp.getDate() + 7 + diferencaCiclo);
    
    return dpp;
  }

  calcularPorConcepcao(dataConcepcao) {
    // Data de concepção + 266 dias (38 semanas)
    const dpp = new Date(dataConcepcao);
    dpp.setDate(dpp.getDate() + 266);
    return dpp;
  }

  calcularPorFIV(dataTransferencia) {
    const tipoFIV = parseInt(document.getElementById('tipo-fiv')?.value || 5);
    const dpp = new Date(dataTransferencia);
    
    // D3: +263 dias | D5: +261 dias
    const diasAdicionar = tipoFIV === 3 ? 263 : 261;
    dpp.setDate(dpp.getDate() + diasAdicionar);
    
    return dpp;
  }

  calcularPorUltrassom(dataUltrassom) {
    const semanas = parseInt(document.getElementById('semanas-ultrassom')?.value || 0);
    const dias = parseInt(document.getElementById('dias-ultrassom')?.value || 0);
    
    const idadeGestacionalDias = (semanas * 7) + dias;
    const diasRestantes = 280 - idadeGestacionalDias;
    
    const dpp = new Date(dataUltrassom);
    dpp.setDate(dpp.getDate() + diasRestantes);
    
    return dpp;
  }

  gerarTag(dpp) {
    const meses = [
      'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
      'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
    ];
    
    const mes = meses[dpp.getMonth()];
    const ano = dpp.getFullYear();
    
    return `DPP_${mes}_${ano}`;
  }

  mostrarResultado(dpp) {
    const meses = [
      'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
      'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'
    ];
    
    const dia = dpp.getDate();
    const mes = meses[dpp.getMonth()];
    const ano = dpp.getFullYear();
    
    const dataFormatada = `${dia} de ${mes} de ${ano}`;
    
    document.getElementById('resultDate').textContent = dataFormatada;
    
    this.form.parentElement.style.display = 'none';
    this.resultDiv.style.display = 'block';
    
    // Scroll suave para o resultado
    this.resultDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  recalcular() {
    this.resultDiv.style.display = 'none';
    this.form.parentElement.style.display = 'block';
    this.form.reset();
    this.mudarCriterio();
    
    // Scroll para o formulário
    this.form.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  mostrarPopup(dpp) {
    this.popupOverlay.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    
    // Re-injetar cores (caso tenham mudado)
    this.injetarCoresPopup();
    
    // Formatar DPP para exibição
    const dia = String(dpp.getDate()).padStart(2, '0');
    const mes = String(dpp.getMonth() + 1).padStart(2, '0');
    const ano = dpp.getFullYear();
    const dppFormatado = `${dia}/${mes}/${ano}`;
    
    // Preencher campos do popup
    const dppDisplayEl = document.getElementById('popupDPPDisplay');
    if (dppDisplayEl) dppDisplayEl.value = dppFormatado;
    
    const hiddenDPPEl = document.getElementById('hiddenDPP');
    if (hiddenDPPEl) hiddenDPPEl.value = dpp.toISOString().split('T')[0];
    
    // Preencher método de cálculo usado
    const criterio = this.criterioSelect?.value || 'ciclo-anterior';
    const hiddenMetodoEl = document.getElementById('hiddenMetodo');
    if (hiddenMetodoEl) hiddenMetodoEl.value = criterio;
    
    console.log('📋 Popup aberto com dados:', {
      dpp: dppFormatado,
      dppISO: dpp.toISOString().split('T')[0],
      metodo: criterio,
      tag: this.tagDPP
    });
  }

  fecharPopup() {
    this.popupOverlay.style.display = 'none';
    document.body.style.overflow = '';
  }

  togglePassword() {
    const senhaInput = document.getElementById('popupSenha');
    if (senhaInput) {
      const type = senhaInput.type === 'password' ? 'text' : 'password';
      senhaInput.type = type;
    }
  }

  voltarParaCalculo(e) {
    e.preventDefault();
    this.fecharPopup();
    this.recalcular();
  }

  mostrarConcepcao(e) {
    e.preventDefault();
    
    if (!this.resultadoDPP) {
      alert('Por favor, calcule a data do parto primeiro.');
      return;
    }
    
    // Data de concepção = DPP - 266 dias
    const concepcao = new Date(this.resultadoDPP);
    concepcao.setDate(concepcao.getDate() - 266);
    
    const meses = [
      'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
      'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'
    ];
    
    const dia = concepcao.getDate();
    const mes = meses[concepcao.getMonth()];
    const ano = concepcao.getFullYear();
    
    alert(`Sua data provável de concepção foi: ${dia} de ${mes} de ${ano}`);
  }

  // Método enviarLead() foi removido - agora é gerenciado pelo script inline no Liquid
  // que usa o formulário nativo do Shopify ({% form 'customer' %})
  
  mostrarSucesso() {
    const popupFormEl = document.querySelector('.jv-calc-popup-form');
    const successDiv = document.getElementById('jvPopupSuccess');
    
    if (popupFormEl) popupFormEl.style.display = 'none';
    if (successDiv) successDiv.style.display = 'block';
    
    console.log('✅ Sucesso exibido!');
    
    // Fechar popup após 3 segundos
    setTimeout(() => {
      this.fecharPopup();
      
      // Resetar popup após fechar
      setTimeout(() => {
        if (popupFormEl) {
          popupFormEl.style.display = 'block';
          popupFormEl.reset();
        }
        if (successDiv) successDiv.style.display = 'none';
      }, 500);
    }, 3000);
  }
}

// Inicializar quando o DOM estiver pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.calculadoraGravidezInstance = new CalculadoraGravidez();
    console.log('✅ Calculadora de Gravidez inicializada');
  });
} else {
  window.calculadoraGravidezInstance = new CalculadoraGravidez();
  console.log('✅ Calculadora de Gravidez inicializada');
}